<template>
  <div :class="{ v2container: source == 'v2' }">
    <!-- 筛选项 -->
    <FilterLayout
      v-model="searchForm"
      @onSubmit="onSubmit"
      width="110px"
      :mdSpan="6"
      :flexFlag="true"
    >
      <div class="component_title2">筛选项</div>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="通知任务ID">
          <el-input v-model.trim="searchForm.task_id" placeholder="请输入id"></el-input>
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="预警指标">
          <el-cascader
            :show-all-levels="false"
            collapse-tags
            :props="{ multiple: true }"
            v-model="searchForm.index_value"
            :options="warn_data_search"
            clearable
          ></el-cascader>
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="通知应用">
          <!-- <el-select v-model="searchForm.appid" multiple placeholder="请选择" collapse-tags filterable clearable>
            <el-option v-for="item in apps_data" :key="item.id" :label="item.title" :value="item.id">
            </el-option>
          </el-select> -->
          <SelectCustomizeNew :value.sync="searchForm.appid" :data="apps_data" />
        </el-form-item>
      </el-col>
      <el-col :md="6" :lg="6" :sm="12">
        <el-form-item label="通知人">
          <!-- <el-select v-model="searchForm.user_id" multiple placeholder="请选择" collapse-tags filterable clearable>
            <el-option v-for="item in warn_user" :key="item.user_id" :label="item.name" :value="item.user_id">
            </el-option>
          </el-select> -->
          <SelectCustomizeNew :value.sync="searchForm.user_id" :data="warn_user" />
        </el-form-item>
      </el-col>
      <el-button @click="initFrom" slot="btn-option">重置筛选</el-button>
    </FilterLayout>

    <!-- 新增按钮 -->

    <div class="btn-box">
      <el-button size="large" type="primary" @click="openDialog">新增通知任务</el-button>
    </div>

    <!-- 数据报表 -->
    <TableLayout
      :column="column"
      :data="tableData.data"
      :total="tableData.total"
      :loading="tableData.loading"
      :currentPage="searchForm.currentPage"
      alignStyle="center"
      @pageChange="onPageChange"
      @sizeChange="onSizeChange"
    >
      <!-- 回显预警指标 -->
      <template #index_name_day="{ row }">
        <div>
          {{ row.index_name_day }}
        </div>
        <div>
          {{ row.index_name_hour }}
        </div>
      </template>

      <!-- 操作 -->
      <template #operate="{ row }">
        <div class="operate-box">
          <el-popconfirm title="确定删除？" @confirm="delList(row)">
            <el-button slot="reference" type="text">删除</el-button>
          </el-popconfirm>
          <el-button type="text" @click="edit(row)">编辑</el-button>
          <el-popconfirm
            :title="`确认${row.status == 1 ? '关闭' : '开启'}通知？`"
            @confirm="statusChange(row)"
          >
            <el-switch :value="row.status == 1 ? true : false" slot="reference" />
          </el-popconfirm>
        </div>
      </template>
    </TableLayout>

    <!-- 新增弹窗 -->
    <el-dialog
      title="新增通知任务"
      :visible.sync="dialogAddVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form :model="addForm" ref="addForm" :rules="rules">
        <el-form-item label="通知应用" label-width="200px" prop="appid">
          <SelectCustomizeNew
            :value.sync="addForm.appid"
            :data="apps_data"
            :styleObj="{
              width: '240px',
            }"
          />
        </el-form-item>

        <el-form-item label="通知人" label-width="200px" prop="user_id">
          <SelectCustomizeNew
            v-model="addForm.user_id"
            :data="warn_user"
            :styleObj="{
              width: '240px',
            }"
          />
        </el-form-item>

        <el-form-item
          label="预警指标"
          label-width="200px"
          v-for="(el, index) in addForm.index"
          :key="index"
          :rules="rules.index"
        >
          <div class="indicator-box">
            <el-cascader
              v-model="el.time_default_value"
              :options="warn_data"
              @change="indexChange"
              clearable
            ></el-cascader>
            <div class="radio-box">
              <div class="title">阀值</div>
              <el-radio-group v-model="el.value_type">
                <el-radio :label="1"
                  >百分比
                  <el-input-number
                    :controls="false"
                    :min="0"
                    style="width: 100px"
                    v-model="el.value"
                    v-show="el.value_type == 1"
                  ></el-input-number>
                  %
                </el-radio>
                <el-radio :label="2">绝对值</el-radio>
                <el-input-number
                  style="width: 100px"
                  :controls="false"
                  :min="0"
                  v-model="el.value"
                  v-show="el.value_type == 2"
                ></el-input-number>
              </el-radio-group>
            </div>
            <!-- 删除 -->
            <el-button
              type="danger"
              size="mini"
              v-show="index != 0"
              @click="delIndicator(index)"
              >刪除</el-button
            >
          </div>
        </el-form-item>
        <div class="ajc" v-if="isShowAdd">
          <el-button type="primary" icon="el-icon-plus" @click="addIndicator"
            >新增</el-button
          >
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adCancel">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FilterLayout from "@/layout/form";
import TableLayout from "@/layout/table";
import _ from "lodash";
import SelectCustomizeNew from "@/component/select-customize-new";
// 指标新增的基础数据格式
let addFormIndexBase = {
  time_default_value: [], // 指标默认数据格式
  index_name: "", // 指标类型的字段
  time_type: "", //指标类型 日 时
  value: "", // 百分比或者是阀值
  value_type: "", // 百分比或者是阀值 类型
};
export default {
  components: {
    FilterLayout,
    TableLayout,
    SelectCustomizeNew,
  },
  data() {
    return {
      source: "",
      dialogAddVisible: false,
      searchForm: {
        task_id: "",
        index_value: [],
        index: [],
        user_id: {
          appInfo: [],
        },
        appid: {
          appInfo: [],
        },
        pageSize: 10,
        currentPage: 1,
      },
      addForm: {
        user_id: {
          appInfo: [],
        },
        appid: {
          appInfo: [],
        },
        index: [
          {
            ...addFormIndexBase,
          },
        ],
      },
      apps_data: [],
      warn_user: [],
      warn_data: [
        {
          value: 2,
          label: "小时级",
          children: [],
        },
        {
          value: 1,
          label: "日级",
          children: [],
        },
      ],
      warn_data_search: [], // 搜索栏的预警指标
      column: [
        {
          label: "通知任务ID",
          prop: "task_id",
        },
        {
          label: "预警指标",
          prop: "index_name_day",
          width: "400",
        },
        {
          label: "通知应用",
          prop: "appid",
        },
        {
          label: "通知人",
          prop: "user_id",
        },
        {
          label: "添加时间",
          prop: "time_add",
        },
        {
          label: "操作",
          width: "160",
          prop: "operate",
        },
      ],
      tableData: {
        data: [],
        total: 0,
        loading: false,
        currentPage: 1,
      },
      rules: {
        appid: [{ required: true, message: "请选择通知应用", trigger: "change" }],
        user_id: [
          {
            required: true,
            message: "请选择通知人",
            trigger: "change",
          },
        ],
        index: {
          required: true,
        },
      },
    };
  },
  created() {
    this.source = this.$route.query.source;
  },
  mounted() {
    // 获取指标时 日指标数据
    this.getWarnData();
    // 获取应用
    this.getApp();
    // 获取通知人
    this.getWarnUser();
    // 列表
    this.getList();
  },
  computed: {
    isShowAdd() {
      let sum1 = this.addForm.index.length;
      let sum2 = this.warn_data[0].children.length + this.warn_data[1].children.length;
      return sum1 < sum2;
    },
  },
  methods: {
    // 获取指标时 日指标数据
    async getWarnData() {
      const [err, res] = await this.$http.post("Index_Warn/getIndex");
      if (err) return;
      const hour_arr = [],
        day_arr = [];
      for (const key in res.hour) {
        let obj = {
          value: key,
          label: res.hour[key],
        };
        hour_arr.push(obj);
      }
      for (const key in res.day) {
        let obj = {
          value: key,
          label: res.day[key],
        };
        day_arr.push(obj);
      }
      this.$set(this.warn_data[0], "children", hour_arr);
      this.$set(this.warn_data[1], "children", day_arr);
      this.warn_data_search = _.cloneDeep(this.warn_data);
    },

    // 获取应用
    async getApp() {
      const [err, res] = await this.$http.post("System/allApps");
      if (err) return;
      for (const i of res) {
        let system = "";
        // let system = i.system == 1 ? '_Android' : i.system == 2 ? '_Ios' :
        switch (Number(i.system)) {
          case 1:
            system = "Android";
            break;
          case 2:
            system = "Ios";
            break;
          case 3:
            system = "微信小程序";
            break;
          case 4:
            system = "抖音小程序";
            break;
          case 5:
            system = "web网页";
            break;
          default:
            system = "未知";
            break;
        }
        i.title = i.title + "_" + system;
      }
      this.apps_data = res;
    },

    // 获取通知人
    async getWarnUser() {
      const [err, res] = await this.$http.post("Index_Warn/getUser");
      if (err) return;
      for (const i of res) {
        i.id = i.user_id;
        i.title = i.name;
      }
      this.warn_user = res;
    },

    // 删除列表
    async delList(row) {
      this.tableData.loading = true;
      const [err, res] = await this.$http.post("Index_Warn/delete", {
        task_id: row.task_id,
      });
      this.tableData.loading = false;
      if (err) return;
      this.getList();
    },

    async getList() {
      this.tableData.loading = true;
      let params = _.cloneDeep(this.searchForm);
      params.appid = params.appid.appInfo;
      params.user_id = params.user_id.appInfo;
      const [err, res] = await this.$http.post("Index_Warn/lists", params);
      this.tableData.loading = false;
      if (err) return;
      this.tableData.total = res.total;
      this.tableData.data = res.lists;
    },

    // 新增指标
    addIndicator() {
      this.addForm.index.push(_.cloneDeep(addFormIndexBase));
    },
    // 删除指标
    delIndicator(index) {
      this.addForm.index.splice(index, 1);
      // 重新计算哪些指标可以使用
      this.indexChange();
    },

    initFrom() {
      this.searchForm = {
        task_id: "",
        index: [],
        index_value: [],
        user_id: {
          appInfo: [],
        },
        appid: {
          appInfo: [],
        },
        pageSize: 10,
        currentPage: 1,
      };
    },
    // 打开弹窗
    openDialog() {
      this.dialogAddVisible = true;
      // 初始化新增表单数据
      this.initadd();
      // 处理指标级联选择器
      this.indexChange();
    },
    // 取消新增
    adCancel() {
      // this.initadd()
      this.dialogAddVisible = false;
    },

    initadd() {
      this.addForm = {
        user_id: {
          appInfo: [],
        },
        appid: {
          appInfo: [],
        },
        index: [
          {
            ...addFormIndexBase,
          },
        ],
      };
    },

    // 确定新增
    async addConfirm() {
      let params = _.cloneDeep(this.addForm);
      params.appid = params.appid.appInfo;
      params.user_id = params.user_id.appInfo;
      if (params.appid.length == 0 || params.user_id.length == 0) {
        return this.$message.warning("通知应用和通知人");
      }
      // 校验是否填写完成
      for (const i of this.addForm.index) {
        const vals = Object.values(i);
        if (vals.indexOf("") > -1 || vals.indexOf(undefined) > -1) {
          return this.$message.warning("请填写预警指标");
        }
      }

      this.tableData.loading = true;
      const [err, res] = await this.$http.post("Index_Warn/save", params);
      this.tableData.loading = false;
      if (err) return;
      this.dialogAddVisible = false;
      this.searchForm.currentPage = 1;
      this.getList();
    },

    // 点击编辑查询

    async edit(row) {
      this.tableData.loading = true;
      const [err, res] = await this.$http.post("Index_Warn/edit", {
        task_id: row.task_id,
      });
      this.tableData.loading = false;
      if (err) return;
      //
      for (const i of res.index) {
        i.time_default_value = [i.time_type * 1, i.index_name];
        i.value_type = i.value_type * 1;
      }
      res.appid = {
        appInfo: res.appid,
      };
      res.user_id = {
        appInfo: res.user_id,
      };
      this.addForm = res;
      this.addForm.task_id = row.task_id;
      this.indexChange();
      this.dialogAddVisible = true;
    },

    // 列表状态改变
    async statusChange(row) {
      this.tableData.loading = true;
      const [err, res] = await this.$http.post("Index_Warn/switch", {
        task_id: row.task_id,
      });
      this.tableData.loading = false;
      if (err) return;
      this.getList();
    },
    // 指标改变
    indexChange(e) {
      // 所有选择的指标字段名称
      const selected_time_name = [];
      for (const i of this.addForm.index) {
        const [time_type = "", index_name = ""] = i.time_default_value;
        i.time_type = time_type;
        i.index_name = index_name;
        if (i.index_name) {
          selected_time_name.push(i.index_name);
        }
      }
      // 每一项只能选一个
      for (let i = 0; i < this.warn_data.length; i++) {
        const el = this.warn_data[i];
        for (let k = 0; k < el.children.length; k++) {
          const item = el.children[k];
          const idx = selected_time_name.findIndex((el) => el == item.value);
          this.$set(this.warn_data[i].children[k], "disabled", idx > -1 ? true : false);
        }
      }
    },
    onSubmit() {
      this.searchForm.currentPage = 1;
      let params = _.cloneDeep(this.searchForm);
      // 重新组合指标数据
      const index_arr = [];
      for (const i of params.index_value) {
        index_arr.push(i[1]);
      }
      this.searchForm.index = index_arr;
      this.getList();
    },
    onPageChange(e) {
      this.searchForm.currentPage = e;
      this.getList();
    },
    onSizeChange(e) {
      this.searchForm.pageSize = e;
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/v2.scss";
</style>

<style lang="less" scoped>
.component_title2 {
  background: #fff;
  padding: 1px 0 10px 15px;
  font-weight: bold;
}

.btn-box {
  margin-top: 20px;
}

.indicator-box {
  display: flex;
  align-items: center;
}

.radio-box {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;

  .title {
    margin-right: 15px;
  }
}

.ajc {
  display: flex;
  align-items: center;
  justify-content: center;
}

.operate-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;
}
</style>
